<template>
  <b-container fluid>
 
<!-- User Interface controls -->

    <b-row>
      <b-col lg="6" class="my-1">
        <b-form-group
          label="Sort"
          label-for="sort-by-select"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sort-by-select"
              v-model="sortBy"
              :options="sortOptions"
              :aria-describedby="ariaDescribedby"
              class="w-75"
            >
              <template #first>
                <option value="">-- none --</option>
              </template>
            </b-form-select>

            <b-form-select
              v-model="sortDesc"
              :disabled="!sortBy"
              :aria-describedby="ariaDescribedby"
              size="sm"
              class="w-25"
            >
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          label="Initial sort"
          label-for="initial-sort-select"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="initial-sort-select"
            v-model="sortDirection"
            :options="['asc', 'desc', 'last']"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          v-model="sortDirection"
          label="Filter On"
          description="Leave all unchecked to filter on all data"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        >
          <b-form-checkbox-group
            v-model="filterOn"
            :aria-describedby="ariaDescribedby"
            class="mt-1"
          >
            <b-form-checkbox value="name">Name</b-form-checkbox>
            <!-- <b-form-checkbox value="age">Age</b-form-checkbox>
            <b-form-checkbox value="isActive">Active</b-form-checkbox> -->
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>

<!-- Main table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="dark"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      sort-icon-left
      stacked="md"
      show-empty
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted header cell for field 'name' -->
      <!-- <template #head(selected)>
        <input type="checkbox" class="lg" @click.stop="toggleSelectAll" name="selectAll" v-model="selectAll">
      </template> -->
      <template #cell(event)="row">
        <!-- {{ row.value.device }}&{{ row.value.eventCode }}: {{ row.value.eventDesc }} -->
        {{ row.value.eventDesc }}
      </template>

      <!-- <template #cell(actions)="row">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Info modal
        </b-button>
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
        <router-link :to="{name: 'edit_user', params: { id: row.item.id }}" class="icons">
              <span class="material-icons">edit</span>
              </router-link>
              <span @click.prevent="deleteUser(row.item.id)" class="material-icons">delete</span>
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
        <b-card no-body>
          <b-tabs pills card vertical>
            <b-tab title="USER" active><b-card-text>
              <ul style="text-align: left;">
                <li>{{ row.item.fullName.last }}{{ row.item.fullName.first }}</li>
                <li>{{ row.item.email }}</li>
                <li>{{ row.item.phone_nr }}</li>
                <li>{{ row.item.address }}</li>
              </ul>
            </b-card-text></b-tab>
            <b-tab title="DOGs" @click="getDogs(row.item.id)" lazy><b-card-text>{{ userDogs[0].name }}</b-card-text></b-tab>
            <b-tab title="CARDs" lazy><b-card-text>dati della CARD</b-card-text></b-tab>
          </b-tabs>
        </b-card>
      </template> -->
    </b-table>

    <b-row>
      <p>
      <span style="float: right">Totale SUBs: {{ totSubs }} pacchetti {{ (totAmount / 100).toFixed(2) }} €</span>
    </p>
    </b-row>
    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- <p>
      <b-button size="sm" @click="selectAllRows">Select all</b-button>
      <b-button size="sm" @click="clearSelected">Clear selected</b-button>
    </p>
    <p>
      Selected Rows:<br>
      {{ selected }}
    </p> -->

<!-- Info modal -->

    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
  </b-container>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import moment from 'moment';

  export default {
    data() {
      return {
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        selectAll: false,
        row: {},
        isBusy: true,
        items: [],
        userDogs: [],
        fields: [
          //{ key: 'selected', label: 'Selected' },
          //{ key: 'surname', label: 'Cognome',  sortable: true,  },
          //{ key: 'name', label: 'Nome',  sortable: true,  },
          { key: 'productName', label: 'Subs', sortable: true, },
          { key: 'WashTot', label: 'Nro Lavaggi',  sortable: true,  },
          { key: 'netPrice', label: 'Prezzo netto',  sortable: true,  
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }
          },
          { key: 'unitCost', label: 'Costo Lavaggio',  sortable: true,  
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }
          },
          { key: 'userRef', label: 'Xref Utente',  sortable: false,  },
          /*{
            key: 'isActive',
            label: 'Attivo',
            // formatter: (value, key, item) => {
              formatter: (value) => {
              return value ? 'Sì' : 'No'
            },
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true
          },*/
          { key: 'actions', label: 'Azioni' }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        totSubs: 0,
        totAmount: 0
      }
    },
    created() {
      this.isBusy = true
      /*const querySnapshot = await db.collectionGroup('subscriptions')
      .where('WashTot', '>=', 7)
      .get();
      querySnapshot.forEach((doc) => {
        console.log(doc.id, ' => ', doc.data());
      });*/

      db.collectionGroup('subscriptions')
      //.orderBy('price.net', 'desc')
      .onSnapshot((snapshotChange) => {
        this.items = [];
        snapshotChange.forEach((doc) => {
          console.log('subs ->', doc.data())
          this.items.push({
            id: doc.id,
            productName: doc.data().productName,
            netPrice: doc.data().price.net,
            unitCost: doc.data().price.unitCost,
            userRef: doc.ref.parent.parent.id,
            WashTot: doc.data().WashTot,
          })
          this.totSubs += 1
          this.totAmount += doc.data().price.net || 0
        });
        this.isBusy = false
        //console.debug(this.items)
      })
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    mounted() {
      // Set the initial number of items
      this.totalRows = this.items.length
    },
    methods: {
      addUser(){
        this.$router.push({ name: 'add_user' })
      },
      onRowSelected(items) {
        this.selected = items
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      toggleSelectAll() {
        this.selectAll = !this.selectAll
        if(this.selectAll) {
          this.selectAllRows()
        } else {
          this.clearSelected()
        }

      },
      getDogs(userRef) {
        db.doc(`users/${userRef}`)
        .collection('dogs')
        .onSnapshot((snapshotChange) => {
          this.userDogs = [];
          snapshotChange.forEach((dog) => {
            console.log('dog ->', dog.data())
            this.userDogs.push({
              id: dog.id,
              name: dog.data().name,
              breedName: dog.data().breedName,
              size: dog.data().size,
              hair: dog.data().hair,
              washPgm: dog.data().washPgm,
            })
            console.log('dogs[0] ->', this.userDogs[0].name)
            //return userDogs[0].name
          })
        })
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    },
    filters: {
      formatDate: function(value) {
        if (!value) return
        else return moment(value, 'X', true).format("DD/MM/YY - HH:mm")
      }
    }
//});
  };
</script>